import { render, staticRenderFns } from "./ActiveContentRemovalModal.vue?vue&type=template&id=079eda72&scoped=true"
import script from "./ActiveContentRemovalModal.vue?vue&type=script&lang=js"
export * from "./ActiveContentRemovalModal.vue?vue&type=script&lang=js"
import style0 from "./ActiveContentRemovalModal.vue?vue&type=style&index=0&id=079eda72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079eda72",
  null
  
)

export default component.exports